// extracted by mini-css-extract-plugin
module.exports = {"checkboxContainer":"checkbox_checkboxContainer__WGzOA","checked":"checkbox_checked___0WzJ","error":"checkbox_error__Xt5XV"};